import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function QualityIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 12H0V16H4V12Z" />
        <path d="M12 12H8V16H12V12Z" />
        <path d="M16 0H12V4H16V0Z" />
        <path d="M16 8H12V12H16V8Z" />
        <path d="M8 4V0H4C1.79086 0 0 1.79086 0 4V8H4V12H8V8H12V4H8Z" />
      </svg>
    </Icon>
  );
}
